import { ReactNode, useEffect, useRef, useState } from "react"
import { LeftMenu } from "../LeftMenu"
import { HelmetHeader } from "./HelmetHeader"
import { useNavigateToElement, useUIHelper } from "../../../biz/hooks/ui/useUIHelper";
import { useTheme } from "../../../biz/hooks/ui/useTheme";
import { Config } from "../../../biz/data/Config";
import { useNavigate, useNavigation } from "react-router-dom";
import { useUser } from "../../../biz/hooks/entities/useUser";
import { SimpleTopMenu } from "../Simple/SimpleTopMenu";
import { SimpleScreenBottom } from "../Simple/SimpleScreenBottom";
import { useFetch } from "../../../biz/hooks/data/useFetcher";
import { useDispatch } from "react-redux";
import { CHANGE_UI_SERVER_BUILD_EPOCH } from "../../../biz/data/redux/uIReducer";
import { PackageName } from "../../..";
import { Portal } from "./Portal";
import { Padder } from "../Simple/SimpleElements";
import { useOrganization } from "../../../biz/hooks/entities/useOrganization";
import { useFlagsLocal } from "../../../biz/hooks/ui/useFlagsLocal";
import { useTranslation } from "react-i18next";
import { useAppData } from "../../../biz/data/useAppData";


export const LoggedInLayout = ({ children, loggedin }: { children: ReactNode, loggedin: boolean }) => {
    const ui = useUIHelper();
    // const nav = useNavigate();
    useEffect(() => {
        if (!!loggedin) {
            ui.handleUIOnLoad();
        }
    }, [, loggedin]);

    if (!loggedin) {
        return (null);
    }

    return (
        <div id="app" className={ui.appUITemplate === "pro" ? "app-pro" : "app-simple"}>
            {ui.appUITemplate === "pro" && (
                <FullUI>
                    {children}
                </FullUI>
            )}

            {ui.appUITemplate === "simple" && (
                <SimpleUI>
                    {children}
                </SimpleUI>
            )}
        </div>
    )
}

const FullUI = ({ children }: { children: ReactNode }) => {
    const ui = useUIHelper();
    return (
        <>
            {/* not scrollable */}
            <div id="ui-leftmenu" className={ui.leftMenuState}>
                <LeftMenu />
            </div>

            {/* scrollable */}
            <div id="ui-rightcontainer">
                <div id="ui-topmenu">

                </div>
                <div id="ui-main">
                    {children}
                </div>
            </div>
        </>

    )
}


const SimpleUI = ({ children }: { children: ReactNode }) => {

    // Build epoch
    const app = useAppData();
    useEffect(() => {
        app.loadBuildEpoch();
    }, []);

    const timer = useRef(null);
    useEffect(() => {
        timer.current = setInterval(() => {
            console.log(Config.isDev ? "timer(dev)..." : "timer...", timer.current, new Date());
            app.loadBuildEpoch();
        }, Config.isDev ? (60 * 1000) : (900 * 1000)) as any;

        return () => { if (timer.current !== null) clearInterval(timer.current); };
    }, []);



    const scroll = useNavigateToElement();
    useEffect(() => {
        if (scroll.elementId) {
            document.getElementById(scroll.elementId)?.scrollIntoView({
                behavior: "smooth"
            });
            scroll.reset();
        }
    }, [scroll.elementId])

    return (
        <>
            <FillProfileReminder />

            {/* scrollable */}
            <div id="ui-simple">
                <SimpleTopMenu />
                {children}
                <SimpleScreenBottom />
                <DoesntWorkOnMobile />
            </div>
        </>
    )
}

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}

const DoesntWorkOnMobile = () => {

    const { t } = useTranslation();

    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const org = useOrganization();
    const large_window = windowDimensions.width > 1024;
    const no_organizations = Object.keys(org.allOrganizations ?? {}).length == 0;

    if (large_window) {
        return (null)
    }

    if (no_organizations) {
        return (null)
    }

    return (
        <Portal visible={true}>
            <div className="use-desktop">


                <div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="169" height="49" viewBox="0 0 169 49" fill="none">
                            <path d="M21.8929 8.22697C21.8929 8.91697 21.8329 9.60693 21.7129 10.2069C21.2629 12.2769 20.0929 13.7469 18.3829 14.347C14.3929 15.757 9.50293 11.437 8.39293 8.55697C7.97293 7.50697 8.51289 6.33696 9.56289 5.91696C10.6129 5.49696 11.7829 6.03696 12.2029 7.08696C12.7429 8.46695 15.7729 10.9869 17.0629 10.5369C17.1529 10.5069 17.4529 10.387 17.6629 9.72697C18.1129 8.25697 17.663 6.21695 17.333 5.76695C16.523 4.98695 16.5229 3.75694 17.3029 2.94694C18.0829 2.13694 19.4029 2.13696 20.2129 2.91696C21.3529 3.99696 21.923 6.24694 21.923 8.28694L21.8929 8.22697Z" fill="#506750" />
                            <path d="M26.693 25.687C26.693 26.407 26.3029 27.127 25.6129 27.487C24.6229 27.997 23.3929 27.637 22.8829 26.647L13.3429 8.49698C12.8029 7.50698 13.1929 6.27697 14.1829 5.76697C15.1729 5.25697 16.4029 5.61696 16.9129 6.60696L26.4529 24.757C26.6029 25.057 26.693 25.387 26.693 25.687Z" fill="#506750" />
                            <path d="M14.7517 16.6269C14.7517 17.7369 14.4218 18.7869 13.7318 19.6269C11.0918 22.9569 4.67173 21.907 2.18173 20.047C1.28173 19.387 1.10178 18.0969 1.76178 17.1969C2.42178 16.2969 3.71173 16.1169 4.61173 16.7769C5.81173 17.6469 9.71176 18.1869 10.5518 17.1069C10.6118 17.0169 10.8217 16.7769 10.6117 16.0869C10.2217 14.6169 8.72176 13.1169 8.21176 12.9069C7.10176 12.6969 6.4418 11.6469 6.6518 10.5369C6.8618 9.42691 8.00179 8.73692 9.08179 8.94692C11.1518 9.36692 13.4618 12.0669 14.3018 14.3469C14.6018 15.1269 14.7217 15.8769 14.7217 16.5969L14.7517 16.6269Z" fill="#506750" />
                            <path d="M27.1417 25.8669C27.1417 26.2269 27.0518 26.5569 26.8718 26.8869C26.3018 27.8469 25.0718 28.1769 24.0818 27.6369L6.32173 17.3769C5.36173 16.8069 5.00173 15.5769 5.57173 14.5869C6.14173 13.6269 7.37171 13.2969 8.36171 13.8369L26.1218 24.0969C26.7818 24.4869 27.1417 25.1469 27.1417 25.8669Z" fill="#506750" />
                            <path d="M11.5751 29.4969C11.5751 33.6369 6.1751 36.9369 3.1751 37.2069C2.0651 37.2969 1.07507 36.4569 0.985071 35.3469C0.895071 34.2369 1.73506 33.2469 2.84506 33.1569C4.31506 33.0369 7.64505 30.8469 7.52505 29.4669C7.52505 29.3769 7.52507 29.0469 6.89508 28.6569C5.63508 27.7869 3.50511 27.6669 2.99511 27.8469C2.03511 28.4169 0.8351 28.0569 0.2651 27.0669C-0.3049 26.1069 0.085038 24.8169 1.04504 24.2769C2.87504 23.2269 6.3851 23.7369 8.5151 24.9069C10.3751 25.9269 11.455 27.4569 11.545 29.2569C11.545 29.3469 11.545 29.4069 11.545 29.4969H11.5751Z" fill="#506750" />
                            <path d="M26.2751 26.4369C26.2751 27.3969 25.6152 28.2369 24.6252 28.4169L4.49518 32.4069C3.38518 32.6169 2.33512 31.8969 2.09512 30.8169C1.85512 29.7069 2.60512 28.6569 3.68512 28.4169L23.8151 24.4269C24.9251 24.2169 25.9751 24.9369 26.2151 26.0169C26.2151 26.1369 26.2452 26.2869 26.2452 26.4069L26.2751 26.4369Z" fill="#506750" />
                            <path d="M19.0422 41.1669C19.0422 43.7469 18.0823 46.4469 16.9423 47.8269C16.2223 48.6969 14.9323 48.8169 14.0923 48.0969C13.2223 47.3769 13.1023 46.0869 13.8223 45.2469C14.7823 44.1069 15.5023 40.2369 14.4823 39.3369C14.3923 39.2769 14.1823 39.067 13.4623 39.217C11.9623 39.517 10.3722 40.9269 10.1322 41.4069C9.86225 42.4869 8.75231 43.087 7.67231 42.817C6.59231 42.547 5.96228 41.377 6.23228 40.297C6.77228 38.257 9.62226 36.1269 11.9323 35.4069C13.9723 34.7769 15.8323 35.107 17.1523 36.307C18.5023 37.507 19.0123 39.337 19.0123 41.227L19.0422 41.1669Z" fill="#506750" />
                            <path d="M26.0922 25.2669C26.0922 25.6569 25.9723 26.0469 25.7623 26.3769L14.4822 43.5069C13.8522 44.4369 12.5922 44.7069 11.6622 44.0769C10.7322 43.4469 10.4622 42.1869 11.0922 41.2569L22.3723 24.1269C23.0023 23.1969 24.2623 22.9269 25.1923 23.5569C25.7923 23.9469 26.1223 24.6069 26.1223 25.2669H26.0922Z" fill="#506750" />
                            <path d="M40.4975 40.837C40.4975 41.587 40.0775 42.307 39.3575 42.667C38.3375 43.147 37.1375 42.757 36.6275 41.737C35.9975 40.447 33.0575 38.557 32.0375 39.037C31.8275 39.127 31.6775 39.397 31.5875 39.787C31.2875 41.137 31.8575 43.027 32.1875 43.417C33.0575 44.107 33.1775 45.337 32.4875 46.237C31.7975 47.107 30.4775 47.227 29.5775 46.537C28.0175 45.307 27.2375 42.007 27.5075 39.727C27.7475 37.687 28.7375 36.1269 30.2975 35.3769C33.9875 33.6369 38.9675 37.297 40.2875 39.967C40.4375 40.267 40.4975 40.567 40.4975 40.867V40.837Z" fill="#506750" />
                            <path d="M36.0275 41.557C36.0275 42.217 35.6975 42.877 35.0975 43.267C34.1675 43.867 32.9075 43.597 32.2775 42.637L21.9275 26.467C21.3275 25.537 21.5975 24.277 22.5575 23.647C23.4875 23.047 24.7475 23.317 25.3775 24.277L35.7275 40.4469C35.9375 40.7769 36.0575 41.1669 36.0575 41.5269L36.0275 41.557Z" fill="#506750" />
                            <path d="M44.9073 13.297C44.9073 13.657 44.8172 14.017 44.6372 14.317C43.6772 16.057 40.5573 17.347 38.2473 17.467C36.1773 17.557 34.4972 16.837 33.5072 15.397C31.1972 12.037 34.0172 6.51698 36.4172 4.80698C37.3472 4.14698 38.6072 4.38695 39.2372 5.28695C39.8972 6.21695 39.6572 7.47696 38.7572 8.10696C37.5872 8.94696 36.2073 12.157 36.8373 13.057C36.9573 13.237 37.2272 13.357 37.6472 13.387C39.0272 13.477 40.7972 12.607 41.1272 12.217C41.6672 11.227 42.8672 10.927 43.8572 11.467C44.5172 11.827 44.8772 12.547 44.8772 13.267L44.9073 13.297Z" fill="#506750" />
                            <path d="M41.0672 10.777C41.0672 11.347 40.8272 11.887 40.3772 12.277L26.0972 25.087C25.2572 25.837 23.9672 25.777 23.2172 24.937C22.4672 24.097 22.5272 22.807 23.3672 22.057L37.6472 9.247C38.4872 8.497 39.7772 8.55701 40.5272 9.39701C40.8872 9.78701 41.0372 10.267 41.0372 10.747L41.0672 10.777Z" fill="#506750" />
                            <path d="M36.2327 5.82699C36.2327 7.86699 34.0427 10.567 32.0027 11.947C30.0527 13.237 28.0427 13.537 26.3027 12.787C24.9227 12.187 23.8427 10.987 23.2127 9.24699C22.3127 6.81699 22.3728 3.51699 23.3328 1.56699C23.8428 0.546993 25.0427 0.157001 26.0627 0.637001C27.0827 1.147 27.4728 2.34697 26.9928 3.36697C26.6028 4.14697 26.4527 6.24698 27.0227 7.83698C27.1727 8.19698 27.4427 8.85696 27.8927 9.03696C28.2527 9.18697 28.7027 9.09699 29.3027 8.82699C30.8027 8.04699 32.0627 6.24696 32.1827 5.70696C32.1827 4.65696 33.0827 3.727 34.1927 3.727C35.3027 3.727 36.2327 4.687 36.2327 5.797V5.82699Z" fill="#506750" />
                            <path d="M31.0127 5.61695C31.0127 5.85695 30.9827 6.06699 30.8927 6.30698L23.9027 25.9569C23.5127 27.0069 22.3727 27.577 21.2927 27.187C20.2427 26.797 19.6726 25.657 20.0626 24.577L27.0527 4.92696C27.4427 3.87696 28.5827 3.30695 29.6627 3.69695C30.5027 3.99696 31.0127 4.77695 31.0127 5.61695Z" fill="#506750" />
                            <path d="M25.2229 23.7971C24.1429 23.4971 23.0329 24.127 22.7329 25.207C22.4329 26.287 23.0629 27.397 24.1429 27.697C24.9229 27.907 100.973 48.667 168.983 45.037V40.957C101.603 44.587 26.0029 23.977 25.2229 23.767V23.7971Z" fill="#506750" />
                        </svg>
                    </div>
                    <div className="header">
                        {t("aSmallObstacle")}
                    </div>
                    <Padder heightPx={16} />
                    <div className="text">
                        {t("ToUseTheAdminPagesYouNeedALargerScreen_")}
                        <br /><br />
                        <span className="bold">
                            {t("inOtherWordsLogInFromAComputerToContinue")}
                        </span>
                    </div>
                    <Padder heightPx={32} />
                    <a href="javascript:history.back()">
                        <div className="goback">
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
                                <path d="M4.02344 13.7702C3.82812 13.5749 3.75 13.3405 3.75 13.0671C3.75 12.8327 3.82812 12.5983 4.02344 12.403L10.8984 5.84052C11.2891 5.48896 11.875 5.48896 12.2266 5.87959C12.5781 6.23115 12.5781 6.85615 12.1875 7.20771L6.99219 12.1296H20.3125C20.8203 12.1296 21.25 12.5593 21.25 13.0671C21.25 13.614 20.8203 14.0046 20.3125 14.0046H6.99219L12.1875 18.9655C12.5781 19.3171 12.5781 19.903 12.2266 20.2936C11.875 20.6843 11.2891 20.6843 10.8984 20.3327L4.02344 13.7702Z" fill="#9F8E73" />
                            </svg>
                            <div>
                                {t("back")}
                            </div>
                        </div>
                    </a>

                </div>

                {/* 
                <div className="bottom-menu-abs">
                    <SimpleScreenBottom />
                </div> 
                */}

            </div>
        </Portal>
    )
}

const FillProfileReminder = () => {

    const flags = useFlagsLocal();

    const nav = useNavigate();
    const { t } = useTranslation();
    const [visible, setVisible] = useState<boolean>(false);

    const ops = useOrganization();
    const org = ops.currentOrganization;
    const [stateUpdate, setStateUpdate] = useState<number>(0);

    useEffect(() => {

        const hide = flags.getOrgBoolFlag(org?.id ?? "", "fill_profile_reminder_hide");
        const ispro = ops.getOrganizationProStatus(org?.id) === "pro" || ops.getOrganizationProStatus(org?.id) === "trial";

        const v = ispro && (
            !org?.customerContactPhone &&
            !org?.customerContactEmail &&
            !org?.showOnMap &&
            !org?.customerContactFacebook &&
            !org?.customerContactInstagram
        );

        if (hide === true) {
            setVisible(false);
        } else {
            setVisible(v);
        }

    }, [, org, stateUpdate]);

    const hideRemider = () => {
        flags.setOrgBoolFlag(org?.id ?? "", "fill_profile_reminder_hide", true);
        setStateUpdate(stateUpdate + 1);
    }

    if (!(visible === true)) {
        return (null);
    }

    return (
        <div className="fill-profile-reminder">
            <div className="inner-container">
                <div className="ico">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                        <path d="M12.5 5.625C10.0391 5.625 7.77344 6.95312 6.52344 9.0625C5.3125 11.2109 5.3125 13.8281 6.52344 15.9375C7.77344 18.0859 10.0391 19.375 12.5 19.375C14.9219 19.375 17.1875 18.0859 18.4375 15.9375C19.6484 13.8281 19.6484 11.2109 18.4375 9.0625C17.1875 6.95312 14.9219 5.625 12.5 5.625ZM12.5 21.25C9.33594 21.25 6.48438 19.6094 4.92188 16.875C3.32031 14.1797 3.32031 10.8594 4.92188 8.125C6.48438 5.42969 9.33594 3.75 12.5 3.75C15.625 3.75 18.4766 5.42969 20.0391 8.125C21.6406 10.8594 21.6406 14.1797 20.0391 16.875C18.4766 19.6094 15.625 21.25 12.5 21.25ZM3.24219 5.46875C3.71094 5.74219 3.82812 6.32812 3.55469 6.75781C2.46094 8.4375 1.875 10.3906 1.875 12.5C1.875 14.6484 2.46094 16.6016 3.55469 18.2422C3.82812 18.7109 3.71094 19.2578 3.24219 19.5703C2.8125 19.8438 2.22656 19.7266 1.95312 19.2578C0.703125 17.3438 0 15 0 12.5C0 10.0391 0.703125 7.69531 1.95312 5.74219C2.22656 5.3125 2.8125 5.19531 3.24219 5.46875ZM21.7188 5.46875C22.1484 5.19531 22.7344 5.3125 23.0078 5.74219C24.2578 7.69531 25 10.0391 25 12.5C25 15 24.2578 17.3438 23.0078 19.2578C22.7344 19.7266 22.1484 19.8438 21.7188 19.5703C21.25 19.2578 21.1328 18.7109 21.4062 18.2422C22.5 16.6016 23.125 14.6484 23.125 12.5C23.125 10.3906 22.5 8.4375 21.4062 6.75781C21.1328 6.32812 21.2891 5.74219 21.7188 5.46875ZM12.5 7.5C13.0078 7.5 13.4375 7.92969 13.4375 8.4375V12.8125C13.4375 13.3594 13.0078 13.75 12.5 13.75C11.9531 13.75 11.5625 13.3594 11.5625 12.8125V8.4375C11.5625 7.92969 11.9531 7.5 12.5 7.5ZM13.75 16.25C13.75 16.9531 13.1641 17.5 12.5 17.5C11.7969 17.5 11.25 16.9531 11.25 16.25C11.25 15.5859 11.7969 15 12.5 15C13.1641 15 13.75 15.5859 13.75 16.25Z" fill="#8F4838" />
                    </svg>
                </div>
                <div className="message">
                    {t("donTForgetToFillInAndSave_")}
                </div>
                <div className="link" onClick={() => { nav(Config.routes.simple_profile) }}>
                    {t("fixit")}
                </div>
                <div className="dismiss" onClick={hideRemider}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                        <path d="M18.4766 7.85156L13.7891 12.5391L18.4375 17.1875C18.8281 17.5391 18.8281 18.125 18.4375 18.4766C18.0859 18.8672 17.5 18.8672 17.1484 18.4766L12.4609 13.8281L7.8125 18.4766C7.46094 18.8672 6.875 18.8672 6.52344 18.4766C6.13281 18.125 6.13281 17.5391 6.52344 17.1484L11.1719 12.5L6.52344 7.85156C6.13281 7.5 6.13281 6.91406 6.52344 6.52344C6.875 6.17188 7.46094 6.17188 7.85156 6.52344L12.5 11.2109L17.1484 6.5625C17.5 6.17188 18.0859 6.17188 18.4766 6.5625C18.8281 6.91406 18.8281 7.5 18.4766 7.85156Z" fill="#D09386" />
                    </svg>
                </div>
            </div>
        </div>
    )
}